import { ResultsPanel as ResultsPanelBase } from "@omni/components/components/Search/SearchBar/components/ResultsPanel/resultsPanel";

import { ResultsPanelComponent } from "@/components/Search/SearchBar/components/ResultsPanel/resultsPanel.component";

export const ResultsPanel = () => {
    return (
        <ResultsPanelBase>
            <ResultsPanelComponent />
        </ResultsPanelBase>
    );
};
